// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__H0XDp","link":"NavBar_link__pSR1b"};